/**
 * If `propValue` is a number, then return it, otherwise return `defaultValue`.
 */
export function numericField(propValue: any, defaultValue: number): number {

  return (typeof propValue === 'number' ? propValue : defaultValue);

}
